<template>
  <!-- Add Diagnosis -->
  <div
    class="card claim-collection-add-card"
    :class="{ 'teal lighten-5': !error, 'red lighten-5': error }"
    v-if="diagnosisCard"
  >
    <div class="card-content">
      <div class="row">
        <form class="col s12">
          <div class="row">
            <div class="col s12">
              <span class="card-title">{{
                resetDiagnosis ? "Edit Diagnosis" : "Add Diagnosis"
              }}</span>
            </div>

            <div class="input-field col s12">
              <input
                v-model="diagnosis"
                id="diagnosis"
                type="text"
              />
              <label class="active" for="diagnosis">Diagnosis</label>
            </div>

            <div class="input-field col s12 claim-entry-actions">
              <a
                class="waves-effect waves-light btn red lighten-2 col s12 m2 left claim-entry-cancel"
                @click.prevent="handleRefresh('diagnosis')"
              >
                <i class="medium material-icons left">clear</i>Cancel
              </a>

               <!-- Breaker -->
              <span class="co1 m7 claim-entry-spacer"></span>

              <button
                  class="waves-effect waves-light btn col s12 m3 right claim-entry-primary"
                  :class="{ 'green': diagnosis }"
                  @click.prevent="handleDiagnosis"
              >
                <i class="medium material-icons left">{{
                  resetDiagnosis ? "sync" : "chevron_right"
                }}</i
                >{{ resetDiagnosis ? "Confirm Edit" : "Next" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Add Claims -->
  <div
    class="card claim-add-card"
    :class="{ 'teal lighten-5': !error, 'red lighten-5': error }"
    v-if="claimsCard"
  >
    <div class="card-content">
      <div class="row">
        <form class="col s12">
          <div class="row">
            <div class="col s12" v-if="!claimsDisplayCard">
              <span class="card-title">Select Item
                <span class="secondary-content tariff-card-actions">
                  <button type="button" class="btn-flat tariff-card-icon-action tariff-preview-top-action"
                    title="View tariff items" @click.prevent="handleTariffPreview" v-if="hasTariffs && !isTariffLoading">
                    <i class="material-icons">visibility</i>
                  </button>
                  <i class="material-icons tariff-mini-spin grey-text" v-if="isTariffLoading">autorenew</i>
                  <button type="button" class="btn-flat tariff-card-icon-action" title="Refresh tariff items"
                    @click.prevent="handleTariffReload" v-else>
                    <i class="material-icons">refresh</i>
                  </button>
                </span>
              </span>
            </div>
            <div class="col s12" v-if="tariffMessage && !isTariffLoading">
              <p class="tariff-card-message">{{ tariffMessage }}</p>
            </div>
            <div class="input-field col s12 m6">
              <TariffSearch
                inputId="filterClaim"
                :data="filterData"
                :startAgain="resetClaim"
                :startEdit="editClaim"
                :disabled="isTariffLoading || !hasTariffs"
                @selected="handlePick"
                @searching="handleSearch"
                @clear="handleClear"
              />
            </div>
            <div class="input-field col s6 m3">
              <input
                v-model="qty"
                @input="handlePricing"
                id="qty"
                type="number"
              />
              <label class="active" for="qty">Quantity</label>
            </div>
            <div class="input-field col s6 m3">
              <input v-model="amt" id="amt" type="number" readonly />
              <label class="active" for="amt">Amount Charged</label>
            </div>

            <div class="input-field col s12 claim-entry-actions">
              <a
                class="waves-effect waves-light btn red lighten-2 col s12 m2 left claim-entry-cancel"
                @click.prevent="handleRefresh('claim')"
              >
                <i class="medium material-icons left">clear</i>Cancel
              </a>

              <a
                  v-if="(type == 'claim') && (editId == null)"
                  class="waves-effect waves-light btn-large col s12 m2 right claim-entry-next"
                  :class="{
                    green: !(selectedItem && qty && amt) && claimsList.length,
                  }"
                  @click="handleNext('review')"
                  ><i class="medium material-icons left">chevron_right</i>Next</a
                >

                <!-- Breaker -->
                <span class="co1 m5 claim-entry-spacer"></span>

              <button
                class="waves-effect waves-light btn black col s12 m3 right claim-entry-primary"
                :class="{ pulse: addPulse }"
                @click.prevent="handleClaims"
              >
                <i class="medium material-icons left">{{
                  editId ? "sync" : "add"
                }}</i
                >{{ editId ? "Edit Item" : "Add Item" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <Teleport to="body">
    <div class="tariff-preview-overlay" @click.self="handleTariffPreviewClose" v-if="isTariffPreviewOpen">
      <section :id="tariffModalId" class="tariff-preview-modal" role="dialog" aria-modal="true" aria-label="Tariff items">
        <button type="button" class="tariff-preview-close" title="Close" @click.prevent="handleTariffPreviewClose">
          <i class="material-icons">close</i>
        </button>
        <div class="tariff-preview-content">
          <h5>Tariff Items</h5>
          <div class="input-field tariff-preview-search">
            <input v-model="tariffPreviewSearch" :id="`${tariffModalId}-search`" type="search" />
            <label class="active" :for="`${tariffModalId}-search`">Search tariff item</label>
          </div>
          <ul class="collection tariff-preview-list" v-if="filteredTariffPreview.length">
            <li class="collection-item" v-for="tariff in filteredTariffPreview" :key="`${tariff.item}-${tariff.price}`">
              <span>{{ tariff.item }}</span>
              <b class="secondary-content">&#8358;{{ formatMoney(tariff.price) }}</b>
            </li>
          </ul>
          <p class="grey-text" v-else>No tariff item matches your search.</p>
        </div>
        <div class="tariff-preview-footer">
          <button type="button" class="btn-flat waves-effect waves-teal" @click.prevent="handleTariffPreviewClose">Close</button>
        </div>
      </section>
    </div>
  </Teleport>
</template>
  
<script>
import { ref, onMounted, computed, watch, watchEffect } from "vue";
import getItems from "@/composables/getItems";
import TariffSearch from "@/components/search/TariffSearch.vue";
import { urlFormat } from "@/composables/tariff/urlFormat";
import { getCache, addCache, removeCache } from "@/composables/cache/cache";
import { capitalizeFirstLetter } from "@/composables/fxLibrary/coreFx.js";

export default {
  name: "AddClaimComponent",
  emits: ["update", "clear"],
  props: ["turl", "type", "next", "reload", "editDiagnosis", "claimItem"],
  components: { TariffSearch },
  setup(props, context) {
    const responseDefault = ref([]);
    const responseSearch = ref([]);
    const error = ref(false);
    const addPulse = ref(false);
    const submitPulse = ref(false);
    const diagnosis = ref(null);
    const diagnosisList = ref([]);
    const diagnosisCard = ref(true);
    const selectedItem = ref(null);
    const selectedPrice = ref(null);
    const resetDiagnosis = ref(false);
    const editClaim = ref(null);
    const editId = ref(null);
    const resetClaim = ref(false);
    const claimsCard = ref(false);
    const claimsDisplayCard = ref(false);
    const claimsSubmitCard = ref(false);
    const claimsList = ref([]);
    const claim = ref(null);
    const qty = ref(null);
    const amt = ref(null);
    const tariffUrl = ref(null);
    const isTariffLoading = ref(false);
    const tariffError = ref(null);
    const tariffLoaded = ref(false);
    const tariffPreviewSearch = ref("");
    const isTariffPreviewOpen = ref(false);
    const tariffModalId = `claimCollectionTariffPreview-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    const hasTariffs = computed(() => responseDefault.value.length > 0);
    const tariffMessage = computed(() => {
      if (tariffError.value) {
        return tariffError.value;
      }
      if (tariffLoaded.value && !hasTariffs.value) {
        return "No tariff item is available for this scheme and provider.";
      }
      return null;
    });
    const filteredTariffPreview = computed(() => {
      const term = tariffPreviewSearch.value?.toLowerCase();
      if (!term) {
        return responseDefault.value;
      }
      return responseDefault.value.filter(x => x.item?.toLowerCase().includes(term));
    });

    // data tariff
    const filterData = computed(() => {
      // start
      let val = {};

      let valPlus;

      if (responseSearch.value) {
        valPlus = responseSearch.value.reduce((newArr, x) => {
          newArr[x.item] = null;
          return newArr;
        }, {});
        val = { ...val, ...valPlus };
      }

      // return final
      return val;
    });

    // search function
    const getTariffFromApi = async (table, force = false) => {
      if (!table) {
        tariffError.value = "Unable to load tariff items for this scheme and provider.";
        tariffLoaded.value = true;
        return;
      }
      tariffUrl.value = table;
      tariffError.value = null;
      // get item from store (cache)
      let cacheTariff = getCache(table);
      // get from api
      if (cacheTariff?.length && !force) {
        responseDefault.value = cacheTariff;
        tariffLoaded.value = true;
      } else {
        isTariffLoading.value = true;
        const { res, err } = await getItems(table);
        if (res.value) {
          // search
          responseDefault.value = res.value.data || [];
          // add cache
          addCache(table, responseDefault.value);
        } else {
          tariffError.value = err.value || "Unable to load tariff items for this scheme and provider.";
        }
        tariffLoaded.value = true;
        isTariffLoading.value = false;
      }
    };

    // updte auth
    onMounted(() => {
      // get props
      if (props.reload) {
        // skip diagnosis
        diagnosis.value = props.reload;
        // call diagnosis handle
        handleDiagnosis();
      }
    });

    // starter (set loading spin)
    onMounted(() => {
      // tariff url
      let url = urlFormat(props.turl);
      // get items from function
      getTariffFromApi(url);
    });

    const handleTariffReload = () => {
      if (!tariffUrl.value) {
        return;
      }
      removeCache(tariffUrl.value);
      getTariffFromApi(tariffUrl.value, true);
    };

    const handleTariffPreview = () => {
      tariffPreviewSearch.value = "";
      isTariffPreviewOpen.value = true;
    };

    const handleTariffPreviewClose = () => {
      isTariffPreviewOpen.value = false;
    };

    const formatMoney = (val) => {
      return Number(val || 0)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // add up
    const totalSent = (claims) => {
      let total = 0;
      claims.forEach((x) => {
        total = Number(total) + Number(x.amt);
      });
      return total
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // refresh field
    const handleRefresh = (type) => {
      if (type === "diagnosis") {
        resetDiagnosis.value = false;
        // clear entry
        diagnosis.value = null;
        // clear pulse (if needed)
        addPulse.value = false;
        // clear error (if needed)
        error.value = false;
         // clear resetDiagnosis in parent (if needed)
        context.emit("clear", {
          id: "resetDiagnosis",
          value: false,
        });
      } else if (type === "claim") {
        // clear entry
        claimInputClear();
      }
      // redirect
      if (claimsList.value.length) {
        handleNext("review");
      } else {
        handleNext("claims");
      }
    };

    // null diagnosis crew
    const handleReviewDiagnosis = () => {
      // clear diagnosis
      diagnosisCard.value = true;
      // true claims
      claimsCard.value = false;
      claimsDisplayCard.value = false;
      claimsSubmitCard.value = false;
      // clear everything about diagnosis
      diagnosis.value = diagnosisList.value.join(", ");
      resetDiagnosis.value = true;

      // clear entry (insurance)
      claimInputClear();

      // clear edit (if needed)
      editId.value = null;
      // clear pulse (if needed)
      addPulse.value = false;
      // clear error (if needed)
      error.value = false;
    };

    // delete claim
    const handleDelete = (claim) => {
      // mark status as delete
      claimsList.value = claimsList.value.filter((x) => x.id != claim.id);
      // clear all input
      claimInputClear();
      // check if all has been removed
      if (!claimsList.value.length) {
        handleNext("claims");
      }
    };

    // edit claim
    const handleEdit = (claim) => {
      // for child component
      editClaim.value = claim.claim;

      // for main
      editId.value = claim.id;
      selectedItem.value = claim.claim;
      selectedPrice.value = claim.standard;
      qty.value = claim.qty;
      amt.value = claim.amt;

      // clear submit outlook
      handleNext("moreClaims");
    };

    // null diagnosis input field
    const handleClearInput = (field) => {
      if (field === "diagnosis") {
        resetDiagnosis.value = false;
        // clear diagnosis
        diagnosis.value = null;
        // clear pulse (if needed)
        addPulse.value = false;
        // clear error (if needed)
        error.value = false;
      }
    };

    // handle diagnosis
    const handleDiagnosis = () => {
      if (diagnosis.value) {
        // format for saving
        const { fx } = capitalizeFirstLetter(diagnosis.value);

        // add to or override diagnosis array
        if (resetDiagnosis.value) {
          diagnosisList.value = [];
          diagnosisList.value.push(fx.value);
        } else {
          diagnosisList.value.push(fx.value);
        }

        // null result
        diagnosis.value = null;
        // reset error (if required)
        error.value = false;
        // clear pulse (if required)
        addPulse.value = false;

        // clear entry (insurance)
        claimInputClear();

         // move straight to review (if edit)
         if (resetDiagnosis.value) {
            resetDiagnosis.value = false;
            // emit clear
            context.emit("clear", {
            id: "resetDiagnosis",
            value: false,
          });
          }

          // Auto-Next
          if (claimsList.value.length) {
              handleNext("review");
            } else {
              handleNext("claims");
            }

      } else {
        error.value = true;
      }
    };

    // clear inputs
    const claimInputClear = () => {
      // clear all
      selectedItem.value = null;
      selectedPrice.value = null;
      resetClaim.value = true; // will clear claims input
      qty.value = null;
      amt.value = null;
      responseSearch.value = [];

      // clear edit (if needed)
      editId.value = null;
      // clear editId in parent (if needed)
      context.emit("clear", {
          id: "editId",
          value: null,
      });
      // clear pulse (if needed)
      addPulse.value = false;
      // clear error (if needed)
      error.value = false;
    };

    // load claims
    const handleClaims = () => {
      // start action
      if (selectedItem.value && qty.value && amt.value) {
        // format for saving
        const { fx } = capitalizeFirstLetter(selectedItem.value);

        if (editId.value) {
          // edit
          const index = claimsList.value.findIndex(
            (x) => x.id === editId.value
          );
          if (index !== -1) {
            // found record
            claimsList.value[index] = {
              ...claimsList.value[index],
              claim: fx.value,
              qty: qty.value,
              amt: amt.value,
            };
          }
        } else {
          // add to claims array
          claimsList.value.push({
            id: Date.now(),
            claim: fx.value,
            qty: qty.value,
            amt: amt.value,
            standard: Number(selectedPrice.value).toFixed(2),
          });
        }

        // clear entry
        claimInputClear();

        /*
        Auth parents onlt
        Others will skip this
        */
        if (props.type == "auth") {
          handleNext("review");
        }

        // reset error (if required)
        error.value = false;
      } else {
        error.value = true;
      }

      // open display
      if (claimsList.value.length) {
        claimsDisplayCard.value = true;
      }
    };

    // handle next
    const handleNext = (next) => {
      if (next === "claims") {
        if (!diagnosis.value && diagnosisList.value.length) {
          // clear diagnosis
          diagnosisCard.value = false;
          // true claims
          claimsCard.value = true;
          claimsDisplayCard.value = false;
          claimsSubmitCard.value = false;
          // clear everything about diagnosis
          diagnosis.value = null;

          // reset error (if required)
          error.value = false;
        } else {
          // set error
          error.value = true;
          // set pulse
          if (diagnosis.value) {
            addPulse.value = true;
          }
        }
      } else if (next === "review") {
        if (
          !(selectedItem.value && qty.value && amt.value) &&
          claimsList.value.length
        ) {
          // clear diagnosis addition card
          diagnosisCard.value = false;
          // true claims
          claimsCard.value = false;
          claimsDisplayCard.value = true;
          claimsSubmitCard.value = true;
          // clear everything about diagnosis (in case it's still active)
          diagnosis.value = null;

          // reset error (if required)
          error.value = false;

          // delay submit pulse
          setTimeout(() => {
            submitPulse.value = true;
          }, 5000);
        } else {
          // set error
          error.value = true;
          // set pulse
          if (selectedItem.value && qty.value && amt.value) {
            addPulse.value = true;
          }
        }
      } else if (next === "moreClaims") {
        // clear diagnosis addition card
        diagnosisCard.value = false;
        // true claims
        claimsCard.value = true;
        claimsDisplayCard.value = false;
        claimsSubmitCard.value = false;
        // clear everything about diagnosis
        diagnosis.value = null;

        // reset error (if required)
        error.value = false;
      }

      // open display
      if (claimsList.value.length) {
        claimsDisplayCard.value = true;
      }
    };

    // watch qty & price
    const handlePricing = () => {
      amt.value = (Number(qty.value) * Number(selectedPrice.value)).toFixed(2);
    };

    // filter components
    const handleSearch = (val) => {
      if (val.item) {
        // sort new search
        responseSearch.value = responseDefault.value.filter((x) =>
          x.item.toLowerCase().includes(val.item.toLowerCase())
        );
      } else {
        // empty search array
        responseSearch.value = [];

        // clear entry
        claimInputClear();
      }
    };

    // null reset
    const handleClear = (val) => {
      resetClaim.value = val.item;
      editClaim.value = val.item;
    };

    // get option
    const handlePick = (val) => {
      //set
      selectedItem.value = val.item;

      //set
      if (selectedItem.value) {
        // get the price out
        responseSearch.value.forEach((x) => {
          if (x.item === selectedItem.value) {
            // found
            selectedPrice.value = x.price;
          }
        });

        // set quantity & amount
        qty.value = 1;
        amt.value = (Number(qty.value) * Number(selectedPrice.value)).toFixed(
          2
        );
      } else {
        // if null (very unlikely)
        // clear entry
        claimInputClear();
      }
    };

    // watch updates
    watchEffect(() => {
      if (diagnosisList.value.length) {
        context.emit("update", {
          claimsDisplayCard: claimsDisplayCard.value,
          claimsSubmitCard: claimsSubmitCard.value,
          claimsList: claimsList.value,
          diagnosisList: diagnosisList.value,
          submitPulse: submitPulse.value,
        });
      }
    });

    // handle delete/edit requests
    const reviewClaim = (val) => {
      if (val) {
        if (val.action == "edit") {
          handleEdit(val.claim);
        } else if (val.action == "delete") {
          handleDelete(val.claim);
        }
      }
    };

    // watch for changes
    watch(props, (newVal) => {
      if (newVal.claimItem) {
        reviewClaim(newVal.claimItem);
        context.emit("clear", {
          id: "claim",
          value: null,
        });
      }
    });

    // watch more changes
    watch(props, (newVal) => {
      if (newVal.editDiagnosis) {
        handleReviewDiagnosis();
      }
    });

     // watch even more changes
     watch(props, (newVal) => {
      if (newVal.next) {
        handleNext(newVal.next);
        context.emit("clear", {
          id: "next",
          value: null,
        });
      }
    });

    return {
      handleClearInput,
      handleDiagnosis,
      handlePricing,
      handleDelete,
      handleEdit,
      handleClaims,
      handleTariffReload,
      handleTariffPreview,
      handleTariffPreviewClose,
      handleReviewDiagnosis,
      handleNext,
      handleSearch,
      handleClear,
      handlePick,
      handleRefresh,
      totalSent,
      selectedItem,
      selectedPrice,
      resetDiagnosis,
      editClaim,
      editId,
      resetClaim,
      filterData,
      filteredTariffPreview,
      formatMoney,
      hasTariffs,
      isTariffLoading,
      isTariffPreviewOpen,
      tariffMessage,
      tariffModalId,
      tariffPreviewSearch,
      error,
      addPulse,
      diagnosis,
      diagnosisList,
      diagnosisCard,
      claimsDisplayCard,
      claimsList,
      claimsCard,
      claim,
      qty,
      amt,
    };
  },
};
</script>
  
<style>
.claim-collection-add-card,
.claim-collection-add-card .card-content,
.claim-collection-add-card form,
.claim-collection-add-card .row,
.claim-collection-add-card .input-field {
  overflow: visible;
}

.claim-collection-add-card {
  position: relative;
  z-index: 20;
}

.claim-collection-add-card .autocomplete-content.dropdown-content {
  max-height: 320px;
  overflow-y: auto;
  z-index: 1200;
}

.claim-add-card .tariff-card-actions {
  align-items: center;
  display: inline-flex;
  gap: 3px;
  margin-top: -2px;
}

.claim-add-card .tariff-card-actions .tariff-card-icon-action.btn-flat {
  align-items: center;
  background-color: #ffffff !important;
  border: 1px solid rgba(84, 110, 122, 0.22);
  border-radius: 18px;
  box-shadow: 0 5px 12px -10px rgba(38, 50, 56, 0.8);
  display: inline-flex;
  height: 34px;
  justify-content: center;
  line-height: 34px;
  min-width: 34px;
  padding: 0;
  width: 34px;
}

.claim-add-card .tariff-card-actions .tariff-card-icon-action.btn-flat:hover {
  background-color: #f8fafb !important;
}

.claim-add-card .tariff-card-actions .tariff-card-icon-action i,
.claim-add-card .tariff-card-actions .tariff-mini-spin {
  color: #546e7a !important;
  font-size: 20px;
  line-height: 20px;
}

.claim-add-card .tariff-card-actions .tariff-mini-spin {
  animation: tariff-spin 0.9s linear infinite;
  align-items: center;
  background-color: #ffffff !important;
  border: 1px solid rgba(84, 110, 122, 0.22);
  border-radius: 18px;
  box-shadow: 0 5px 12px -10px rgba(38, 50, 56, 0.8);
  display: inline-flex;
  height: 34px;
  justify-content: center;
  text-align: center;
  width: 34px;
}

.tariff-card-message {
  background: #fff8e1;
  border-radius: 6px;
  color: #6d4c41;
  margin: 8px 0 0;
  padding: 10px 12px;
}

.tariff-preview-overlay {
  background: rgba(38, 50, 56, 0.48);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1200;
}

.tariff-preview-modal {
  background: #fff;
  bottom: 32px;
  box-shadow: 0 18px 45px rgba(38, 50, 56, 0.24);
  display: flex;
  flex-direction: column;
  left: max(36px, calc((100vw - 1180px) / 2));
  position: fixed;
  right: max(36px, calc((100vw - 1180px) / 2));
  top: 104px;
  z-index: 1201;
}

.tariff-preview-content {
  flex: 1;
  overflow: hidden;
  padding: 32px 36px 20px;
}

.tariff-preview-search {
  margin-bottom: 22px;
  margin-top: 22px;
}

.tariff-preview-list {
  max-height: calc(100vh - 330px);
  overflow-y: auto;
}

.tariff-preview-close {
  background: #eceff1;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  height: 36px;
  position: absolute;
  right: 24px;
  top: 22px;
  width: 36px;
}

.tariff-preview-close i {
  color: #455a64;
  line-height: 36px;
}

.tariff-preview-footer {
  border-top: 1px solid #e0e0e0;
  padding-left: 36px;
  padding-right: 36px;
  text-align: right;
}

@media only screen and (max-width: 992px) {
  .claim-entry-actions {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .claim-entry-actions .claim-entry-spacer {
    display: none;
  }

  .claim-entry-actions .claim-entry-primary,
  .claim-entry-actions .claim-entry-next,
  .claim-entry-actions .claim-entry-cancel {
    float: none !important;
    margin: 0;
    order: 2;
    width: 100% !important;
  }

  .claim-entry-actions .claim-entry-primary {
    order: 1;
  }

  .claim-entry-actions .claim-entry-next {
    order: 2;
  }

  .claim-entry-actions .claim-entry-cancel {
    order: 3;
  }
}

@media only screen and (max-width: 600px) {
  .tariff-preview-modal {
    bottom: 12px;
    left: 12px;
    right: 12px;
    top: 76px;
  }

  .tariff-preview-content {
    padding: 24px 18px 16px;
  }

  .tariff-preview-list {
    max-height: calc(100vh - 292px);
  }
}

@keyframes tariff-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
  
